<template>
  <div class="meetup-widget">
    <div class="meetup-widget__header">
      <a
        class="meetup-widget__header-link"
        href="#"
        rel="noopener noreferrer"
        target="_blank"
      >
        meet-up
      </a>
    </div>
    <div class="meetup-widget__inner">
      <span class="meetup-widget__date">29 ноября, 11:00</span>
      <div class="meetup-widget__description">
        Теория и практика работы с Kubernetes в облаке на базе VMware
      </div>
      <a
        class="meetup-widget__link btn btn--xs btn--outline"
        href="#"
        rel="noopener noreferrer"
        target="_blank"
      >
        Зарегистрироваться
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MeetUpWidget'
  }
</script>

<style lang="scss">
  .meetup-widget {
    display: flex;
    flex-direction: column;
    margin: 12px 0;
    background-color: #FFF;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.1),
    0 4px 16px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
  }

  .meetup-widget__header {
    height: 160px;
    overflow: hidden;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-image: url('~@/assets/images/header/meetup.jpg');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .meetup-widget__header-link {
    z-index: 2;
    position: relative;
    display: inline-block;
    margin: 24px;
    padding: 2px 6px;
    background-color: #FFF;
    border-radius: 4px;
    color: $primary;
    transition: 0.2s;

    @include text--xs;

    &:hover {
      background-color: $secondary;
      color: #FFF;
    }
  }

  .meetup-widget__inner {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 24px;

    @include text--sm;
  }

  .meetup-widget__date {
    display: block;
    margin-bottom: 16px;
  }

  .meetup-widget__description {
    margin-bottom: 16px;
  }

  .meetup-widget__link {
    margin-top: auto;
  }
</style>